import BjsHome from "./pages/Subservices/BJS/Home";
import CpwmHome from "./pages/Subservices/CPWM/Home";
import PjwHome from "./pages/Subservices/PJW/Home";
import ApssHome from "./pages/Subservices/APSS/Home";
import BocHome from "./pages/Subservices/BOC/Home";
import CirkHome from "./pages/Subservices/CIRK/Home";
import ChpeHome from "./pages/Subservices/CHPE/Home";
import HhmHome from "./pages/Subservices/HHM/Home";
import LrgHome from "./pages/Subservices/LRG/Home";
import { Service } from "./context/qualifiers/types/StateType";

export const serviceIds = JSON.parse(process.env.REACT_APP_SERVICES || "{}");

interface Services {
	[key: string]: Service;
}

const imageBaseUrl = process.env.REACT_APP_S3_IMAGE_BASE_URL;

function defineService(
	key: string,
	config: Omit<Service, "id" | "name" | "parentId" | "hideProductLevel" | "filterLevel"> & {
		name?: string;
		hideProductLevel?: boolean;
		filterLevel?: number;
	}
): Service {
	const name = config.name ?? key;
	return {
		id: serviceIds[key].id,
		name,
		parentId: serviceIds[key].parentId,
		hideProductLevel: false,
		filterLevel: 1,
		logoUrl: `${name}_logo.png`,
		bannerImage: `url(${imageBaseUrl}/${name}/${name}_banner.jpg)`,
		...config,
	};
}

const services: Services = {
	mfbt: defineService("mfbt", {
		fullName: "My Food & Bev Training",
		typeId: 1,
	}),
	bjs: defineService("bjs", {
		fullName: "BJ's Wholesale Club",
		typeId: 3,
		homeComponent: BjsHome,
	}),
	cpwm: defineService("cpwm", {
		fullName: "World Market",
		typeId: 4,
		homeComponent: CpwmHome,
	}),
	pjwrg: defineService("pjwrg", {
		fullName: "PJW Restaurant Group",
		typeId: 6,
		homeComponent: PjwHome,
		hideProductLevel: true,
	}),
	aplus: defineService("aplus", {
		fullName: "A+ Staffing",
		typeId: 7,
		homeComponent: ApssHome,
		hideProductLevel: true,
	}),
	boc: defineService("boc", {
		fullName: "Brewer Oil Company",
		typeId: 8,
		homeComponent: BocHome,
	}),
	circlek: defineService("cirk", {
		name: "circlek",
		fullName: "Circle K Rocky Mountain Division",
		typeId: 9,
		homeComponent: CirkHome,
		colorPrimary: "#da291c",
		colorSecondary: "#ed8b00",
	}),
	chpe: defineService("chpe", {
		fullName: "Chickie's and Pete's",
		typeId: 10,
		homeComponent: ChpeHome,
		colorPrimary: "#be0000",
		colorSecondary: "#790E0E",
	}),
	hhm: defineService("hhm", {
		fullName: "HHM Hotels",
		typeId: 11,
		homeComponent: HhmHome,
		colorPrimary: "#1e5097",
		colorSecondary: "#e35205",
	}),
	lrg: defineService("lrg", {
		fullName: "LaScala Restaurant Group",
		typeId: 12,
		homeComponent: LrgHome,
		colorPrimary: "#bc252c",
		colorSecondary: "#1a1a1a",
		bannerImage: `url(${imageBaseUrl}/lrg/lrg_banner.png)`,
	}),
};

export default services;
